/**
 * A move can carry several raw classifications, but the UI presents one clear
 * verdict. A book move takes precedence: opening theory is more useful than a
 * redundant quality label such as "excellent".
 */
const MOTIF_PRIORITY = [
  "checkmate",
  "book",
  "brilliant",
  "best",
  "excellent",
  "good",
  "blunder",
  "opponent_blunder",
  "mistake",
  "opponent_mistake",
  "imprecision",
  "opponent_imprecision",
  "time_pressure",
  "low_time",
  "opening_phase",
  "endgame_phase",
] as const;

export const primaryMotif = (motifs: Iterable<string>): string | null => {
  const present = new Set(motifs);
  return MOTIF_PRIORITY.find((motif) => present.has(motif)) ?? null;
};
